import { Configuration, PopupRequest } from '@azure/msal-browser';

const MSAL_SCOPE_URI = process.env.REACT_APP_MSAL_SCOPE_URI || 'api://voucher-service-api-test';

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID || '',
    authority: 'https://login.microsoftonline.com/' + process.env.REACT_APP_MSAL_TENANT_ID || '',
    redirectUri: '/',
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ['User.Read'],
};

export const apiRequest: PopupRequest = {
  scopes: [`${MSAL_SCOPE_URI}/Voucher.Read`],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
